// extracted by mini-css-extract-plugin
module.exports = {"appHeader":"About_appHeader__rftS5","aboutText":"About_aboutText__1fwP3","techStack":"About_techStack__yLedx","listItem":"About_listItem__2m9nJ"};